export default __webpack_public_path__ + "images/6eee74956b50292d58a3eaeccacc1e76-pride_touchpoint_image.webp";